export default __webpack_public_path__ + "static/media/train-alt.7bcf78c0.svg";